'use client';

import type { NavBar } from '@/api/types/navigationTypes';
import { isUserAuthenticated } from '@/features/auth/client';
import { cn } from '@/utils/ui';

import { NavigationItem } from './NavigationItem';

interface NavBarProps {
  subNavBar?: NavBar;
}

export function TopRightNav({ subNavBar }: NavBarProps): React.ReactNode {
  const isAuthenticated = isUserAuthenticated();

  const subscriptionSection = subNavBar?.subitems?.find((item) => item.item_key === 'subscriptions');
  const subscriptionItems = subscriptionSection?.subitems ?? [];

  if (!isAuthenticated || subscriptionItems.length === 0) {
    return null;
  }

  return (
    <>
      <li className="flex md:hidden">
        <div className="ml-[53px] py-4 pt-8 font-FoxOneAeroBold text-[18px]/[23px] text-base-white opacity-50 md:ml-0 md:py-0">
          <span>Subscriptions</span>
        </div>
      </li>
      <ul className="flex w-full flex-col md:hidden">
        {subscriptionItems.map((item) => {
          const isLocked = item.visibility === 'locked';

          return (
            <NavigationItem
              key={item.nav_item_id}
              className={cn({ 'order-first': !isLocked })}
              navItem={item}
              type="subscription"
            />
          );
        })}
      </ul>
    </>
  );
}
